import { FormClassifiedInfo } from '~/models/classified/form'
import { ClassifiedEditMarketplaceInfo } from '~/models/classified/edit'

export const CLASSIFIED_EDIT_NS = 'classifieds/edit'

export interface EditState {
  info?: FormClassifiedInfo
  owner: any
  category?: any
  registerReferenceCode?: string
  marketplace: ClassifiedEditMarketplaceInfo | null
}
function getDefaultState(): EditState {
  return {
    category: undefined,
    info: undefined,
    owner: null,
    registerReferenceCode: undefined,
    marketplace: null
  }
}

export default getDefaultState
